<template>
  <el-container>
    <el-header>
      <common-header/>
    </el-header>
    <div class="banner banner1">
      <div class="maincontainer">
        <div class="iconapply"></div>
        <div class="title">{{ $t('lang.chooseCert.wantToApply') }}</div>
        <div class="step">
          <div class="step-title">{{ $t('lang.chooseCert.choosePackage') }}</div>
          <div class="step-no">STEP<span>2</span></div>
        </div>
      </div>
    </div>
    <el-main>
      <div class="maincontainer" style="padding: 50px 0 20px 0">
        <el-collapse v-model="activeNames" style="margin: 0 20px">
          <el-collapse-item
            :name="'package' + index"
            v-for="(item, index) in packList"
            :key="'pack_' + index"
          >
            <template slot="title">
              {{ $t('lang.chooseCert.package') + (index + 1) }}
              <i :class="isActive('package' + index) ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              <!--              <template v-if="!disabled">
                              <template v-if="index === 0">
                                <el-tooltip placement="top" :content="$t('lang.chooseCert.addPackageTooltip')">
                                  <el-button type="text" class="btnaddpackage alignright" @click.stop="addPackage">
                                    <i class="icon iconfont icon-wenjianjia"></i>
                                    {{ $t('lang.chooseCert.addPackage') }}
                                  </el-button>
                                </el-tooltip>
                              </template>
                              <template v-else>
                                <el-button type="text" class="btnaddpackage" @click.stop="addPackage">
                                  <i class="icon iconfont icon-wenjianjia"></i>
                                  {{ $t('lang.chooseCert.addPackage') }}
                                </el-button>
                              </template>
                              <el-button type="text" class="btndelpackage" v-if="index>0" @click.stop="removePackage(index)">
                                <i class="icon iconfont icon-wenjianjia-"></i>
                                {{ $t('lang.chooseCert.removePackage') + (index + 1) }}
                              </el-button>
                            </template>-->
            </template>
            <div class="filelist">
              <el-row class="rowheader">
                <el-col :span="4">{{ $t('lang.chooseCert.certType') }}</el-col>
                <el-col :span="6">{{ $t('lang.chooseCert.certName') }}</el-col>
                <el-col :span="8" style="text-align: center">{{ $t('lang.chooseCert.amount') }}</el-col>
                <el-col :span="4" style="text-align: center">{{ $t('lang.chooseCert.remainCopyNumber') }}</el-col>
                <el-col :span="2" style="text-align: center">{{ $t('lang.chooseCert.sumAmount') }}</el-col>
              </el-row>
              <el-row
                class="filerow"
                v-for="(dItem, dIndex) in item.selectedCertList"
                :key="'detail_' + dIndex"
              >
                <el-col :span="4">{{ matchCertType(dItem.certTypeCode) }}</el-col>
                <el-col :span="6">{{ isZh ? dItem.chineseName : dItem.englishName }}</el-col>
                <el-col :span="8" style="text-align: center">
                  <el-input-number
                    size="mini"
                    :min="0"
                    :max="index === 0 ? dItem.copyNumber + remainCopyNumber(dItem.id) : certIdMaxCopyNumberMap.get(dItem.id)"
                    :step="1"
                    v-model="dItem.copyNumber"
                    :disabled="disabled"
                    @change="(curVal, oldVal) => onCopyNumberChange(curVal, oldVal, dItem, index)"
                  ></el-input-number>
                </el-col>
                <el-col :span="4" style="text-align: center">{{ remainCopyNumber(dItem.id) }}</el-col>
                <el-col :span="2" style="text-align: center">
                  {{ certChargeAmount(dItem, index) | moneyFormat }}
                </el-col>
              </el-row>
              <div class="need-seal-wrapper">
                <div>
                  <el-checkbox v-model="item.seal" @change="forceUpdate" :disabled="disabled">{{
                      $t('lang.chooseCert.needSeal')
                    }}
                  </el-checkbox>
                </div>
                <div class="remark">
                  ({{ $t('lang.chooseCert.sealCharge') }}{{ sealCharge(index) | moneyFormat }})
                </div>
              </div>
              <div class="need-seal-wrapper">
                <div>
                  <el-checkbox v-model="item.addNextPackage" @change="onAddPackageCheckboxChange(index)"
                               :disabled="disabled">{{
                      $t('lang.chooseCert.addPackage') + (index + 2)
                    }}
                  </el-checkbox>
                </div>
                <div class="remark">
                  ({{ $t('lang.chooseCert.addPackageTooltip') }})
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <!--      <div class="maincontainer" style="position:relative">
              <div class="totalinfo">
                <div>{{ $t('lang.chooseCert.totalAmount') }}</div>
                <div>CNY<br/>人民币</div>
                <div class="toatlamount">
                  {{ totalAmount | moneyFormat }}
                  &lt;!&ndash;            {{ totalamount | moneyFormat }}&ndash;&gt;
                </div>
              </div>
            </div>-->
      <div class="maincontainer">
        <el-button
          size="mini"
          style="width: 250px"
          type="ceibs"
          @click="goBack">{{ $t('lang.common.goBack') }}
        </el-button>
        <el-button
          size="mini"
          style="width: 250px"
          type="ceibsprimary"
          :disabled="disabled"
          @click="submit">{{ $t('lang.common.goNext') }}
        </el-button>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import CommonHeader from '@/components/common/commonHeader'
import { mapGetters } from 'vuex'
import languageType from '@/locales/languageType'
import { getChargeConfig, listDictByType } from '@/api/base'
import { getAccessToken, getRefreshToken } from '@/util/util.ruquest'
import { loadStudentInfo } from '@/api/apply'

export default {
  name: 'certPackage',
  components: { CommonHeader },
  props: {
    applyVo: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      seal: true,
      activeNames: ['package0'],
      packList: [],
      certTypeDict: [],
      certIdMaxCopyNumberMap: new Map(),
      sealChargeConfig: null,
      totalAmount: 0,
      studentInfo: null
    }
  },
  mounted () {
    this.loadStudentInfo()
    this.initCertTypeDict()
    this.loadSealChargeRule()
    this.initPackList()
  },
  watch: {
    packList: {
      handler (nval, oval) {
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters([
      'currentLanguage'
    ]),
    isLogin: function () {
      return getAccessToken() && getRefreshToken()
    },
    currentUserInSchool: function () {
      return this.studentInfo && this.studentInfo.STATUS === '0'
    },
    isZh: function () {
      return this.currentLanguage === languageType.zh.code
    },
    detailList: function () {
      const detailList = []
      this.packList.forEach(pack => {
        detailList.push(...pack.selectedCertList)
      })
      return detailList
    },
    remainCopyNumber: function () {
      const me = this
      return function (certId) {
        const maxCopyNumber = me.certIdMaxCopyNumberMap.get(certId)
        let curCopyNumber = 0
        me.detailList.forEach(item => {
          if (item.id === certId) {
            curCopyNumber += item.copyNumber
          }
        })
        return maxCopyNumber - curCopyNumber
      }
    },
    sealCharge: function () {
      const me = this
      return function (packageIndex) {
        if (me.sealChargeConfig && me.packList[packageIndex].seal) {
          if (me.sealChargeConfig.chargeMode === 'UNIT_PRICE') {
            return me.sealChargeConfig.priceRmb
          } else {
            let sealCount = 0
            for (let i = 0; i <= packageIndex; i++) {
              if (me.packList[i].seal) {
                sealCount++
              }
            }
            const configByStep = me.sealChargeConfig.stepList.filter(config => config.stepFrom <= sealCount && config.stepTo >= sealCount)[0]
            if (configByStep) {
              return configByStep.priceRmb
            } else {
              // 未匹配到阶梯
              return me.sealChargeConfig.stepList[me.sealChargeConfig.stepList.length - 1].priceRmb
            }
          }
        } else {
          return 0
        }
      }
    }
  },
  methods: {
    goto (url) {
      this.$router.push(url)
    },
    next () {
      const url = '/apply/gettype'
      this.goto(url)
    },
    isActive (name) {
      return (
        this.activeNames.findIndex((item) => {
          return item === name
        }) > -1
      )
    },
    goBack () {
      this.$emit('changeStep', 'chooseCert')
    },
    loadStudentInfo () {
      if (this.isLogin) {
        loadStudentInfo().then(res => {
          this.studentInfo = res.data
        })
      }
    },
    initPackList () {
      const tempPackVoList = this.applyVo.tempPackVoList
      for (let i = 0; i < tempPackVoList.length; i++) {
        const pack = tempPackVoList[i]
        pack.seal = pack.packageType === 'SEAL'
        if (i < tempPackVoList.length - 1) {
          // 非最后一个
          pack.addNextPackage = true
        }
        if (pack.selectedCertList) {
          pack.selectedCertList.forEach(item => {
            if (this.certIdMaxCopyNumberMap.has(item.id)) {
              const curNum = this.certIdMaxCopyNumberMap.get(item.id)
              this.certIdMaxCopyNumberMap.set(item.id, curNum + item.copyNumber)
            } else {
              this.certIdMaxCopyNumberMap.set(item.id, item.copyNumber)
            }
          })
        }
      }
      this.packList.push(...tempPackVoList)
      this.calculateTotalAmount()
    },
    initCertTypeDict () {
      listDictByType({
        type: 'CERT_TYPE'
      }).then(res => {
        this.certTypeDict = res.data
      })
    },
    loadSealChargeRule () {
      getChargeConfig({
        chargeType: 'SEAL'
      }).then(res => {
        this.sealChargeConfig = res.data
      })
    },
    matchCertType (certTypeCode) {
      if (certTypeCode && this.certTypeDict.length > 0) {
        const matchedCertType = this.certTypeDict.filter(dict => dict.code === certTypeCode)[0]
        if (matchedCertType) {
          return this.isZh ? matchedCertType.chineseName : matchedCertType.englishName
        } else {
          return ''
        }
      }
      return ''
    },
    forceUpdate () {
      this.$forceUpdate()
      this.calculateTotalAmount()
    },
    onAddPackageCheckboxChange (index) {
      if (this.packList[index].addNextPackage) {
        this.addPackage()
      } else {
        this.removePackage(index + 1)
      }
    },
    addPackage () {
      // 复制第一个包装袋
      const newPackage = JSON.parse(JSON.stringify(this.packList[0]))
      // copyNumber设置为0
      newPackage.selectedCertList.forEach(item => {
        item.copyNumber = 0
      })
      newPackage.seal = false
      newPackage.addNextPackage = false
      this.packList.push(newPackage)
    },
    removePackage (index) {
      this.packList.splice(index, 1)
    },
    calculateTotalAmount () {
      let certAmount = 0
      this.detailList.forEach(item => {
        certAmount += item.chargeAmountRmb * item.copyNumber
      })
      let sealAmount = 0
      this.packList.forEach((pack, index) => {
        sealAmount += this.sealCharge(index)
      })
      this.totalAmount = certAmount + sealAmount
    },
    submit () {
      for (const detail of this.detailList) {
        if (this.remainCopyNumber(detail.id) > 0) {
          this.$message.error(this.$t('lang.chooseCert.validate.pleaseAssignRemainCopyNumber') + (this.isZh ? detail.chineseName : detail.englishName))
          return
        }
      }
      this.$emit('submit', this.packList.map((pack, index) => {
        return {
          packageType: pack.seal ? 'SEAL' : 'NORMAL',
          packageNo: index + 1,
          selectedCertList: pack.selectedCertList.filter(cert => cert.copyNumber > 0)
        }
      }))
    },
    onCopyNumberChange (curVal, oldVal, dItem, packIndex) {
      if (this.remainCopyNumber(dItem.id) < 0) {
        // 说明当前copyNumber不合法 超过了总和
        if (packIndex === 0) {
          // 操作的是第一个文件袋，撤回本次操作
          dItem.copyNumber = oldVal
        } else {
          // 非第一个文件袋，判断第一个文件袋是否有余量
          const pack0Item = this.packList[0].selectedCertList.filter(cert => cert.id === dItem.id)[0]
          if (pack0Item.copyNumber > 0) {
            // 第一个文件袋有余量，扣除第一个文件袋copyNumber
            pack0Item.copyNumber = pack0Item.copyNumber - (curVal - oldVal)
          } else {
            // 第一个文件袋无余量，撤回本次操作
            dItem.copyNumber = oldVal
          }
        }
      }
      this.forceUpdate()
    },
    certChargeAmount (cert, packageIndex) {
      if (cert.needCharge === 'N') {
        return 0
      }
      if (this.currentUserInSchool && cert.inSchoolStudentFree === 'Y') {
        return 0
      }
      if (cert.certChargeMode === 'UNIT_PRICE') {
        return cert.chargeAmountRmb * cert.copyNumber
      } else if (cert.certChargeMode === 'FIRST_COPY') {
        if (packageIndex === 0) {
          // 是第一个文件袋 copyNumber > 0 时，价格=首份单价+后续单价*(数量-1)
          return cert.copyNumber > 0 ? cert.firstCopyPriceRmb + (cert.copyNumber - 1) * cert.chargeAmountRmb : 0
        }
        // 从当前packageIndex向前找，看有没有copyNumber>1的
        let hasCopyNumberBefore = false
        for (let i = packageIndex - 1; i >= 0; i--) {
          if (this.packList[i].selectedCertList.filter(c => c.id === cert.id && c.copyNumber > 0).length > 0) {
            hasCopyNumberBefore = true
            break
          }
        }
        // 如果有，说明不是首份，价格 = 后续单价*数量，是首份，价格=首份单价+后续单价*（数量-1）
        if (hasCopyNumberBefore) {
          return cert.copyNumber * cert.chargeAmountRmb
        }
        return cert.firstCopyPriceRmb + (cert.copyNumber - 1) * cert.chargeAmountRmb
      }
      return 0
    }
  }
}
</script>

<style scoped>

.price {
  position: absolute;
  top: 0;
  right: 40px;
  line-height: 35px;
  font-family: Arial, Helvetica, sans-serif;
}

.price .unit {
  font-size: 18px;
}

.price .amount {
  margin-left: 40px;
}

/deep/ .el-collapse {
  border: none;
}

/deep/ .el-collapse-item {
  position: relative;
  margin-bottom: 25px;
}

/deep/ .el-collapse-item__header {
  background-color: #848484;
  color: #fff;
  text-align: center;
  display: block;
  border-left: 5px solid #a2100e;
  border-bottom: none;
  font-size: 16px;
  height: 35px;
  line-height: 35px;
  box-shadow: -1px 3px 11px 2px rgb(136 136 136 / 51%);
  position: relative;
}

/deep/ .el-collapse-item__header.is-active {
  background-color: #a2100e;
}

/deep/ .el-collapse-item__header i {
  font-size: 12px;
  margin-left: 15px;
}

/deep/ .el-collapse-item__arrow {
  display: none;
}

/deep/ .el-icon-arrow-right::before {
  content: "";
}

/deep/ .el-collapse-item__wrap {
  border: none;
}

.filelist {
  text-align: left;
  color: #707070;
}

/deep/ .el-upload {
  color: #707070;
}

/deep/ .el-collapse-item__content {
  padding-bottom: 0;
}

.filelist .rowheader {
  font-size: 12px;
  color: #a2100e;
  padding: 10px 0 5px 0;
}

.filelist .filerow {
  margin: 5px 0;
  font-size: 12px;
  line-height: 35px;
}

.filerow:nth-child(odd) {
  background-color: #ededed;
}

.filerow .el-col {
  line-height: 45px;
}

.filerow .fileuploadcontainer.el-col {
  line-height: 40px;
}

.filerow .el-col:first-child {
  padding-left: 15px;
}

.rowheader .el-col:first-child {
  padding-left: 15px;
}

.fileprice {
  text-align: center;
}

.rowselected .fileprice {
  color: #a2100e;
}

.fileuploadcontainer {
  display: flex;
  align-items: center;
  justify-content: left;
}

.fileuploadcontainer i {
  font-size: 25px;
}

.rowselected .fileuploadcontainer i {
  color: #a2100e;
}

.totalinfo {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-align: right;
  padding-right: 30px;
  color: #5b5b5b;
  padding-bottom: 30px;
}

.totalinfo div:first-child {
  font-size: 36px;
  font-weight: bold;
}

.totalinfo div:last-child {
  font-size: 36px;
  color: #a2100e;
  margin-left: 15px;
}

/deep/ .el-icon-minus::before {
  content: "\e7a2";
  font-size: 30px;
}

/deep/ .el-icon-plus::before {
  content: "\e7a0";
  font-size: 30px;
}

/deep/ .el-input-number__decrease {
  width: 24px;
  height: 24px;
  border: none;
  background-color: unset;
  left: 0;
  top: 0;
  color: #a2100e;
}

/deep/ .el-input-number__decrease.is-disabled,
.el-input-number__increase.is-disabled {
  color: unset;
}

/deep/ .el-input-number__increase {
  width: 24px;
  height: 24px;
  border: none;
  background-color: unset;
  top: 0;
  right: 4px;
  color: #a2100e;
}

/deep/ .btnaddpackage {
  position: absolute;
  top: -55px;
  right: 150px;
  color: #707070;
  font-size: 12px;
  line-height: 30px;
}

/deep/ .btnaddpackage span {
  display: flex;
}

/deep/ .alignright {
  right: 0;
}

/deep/ .btnaddpackage i {
  font-size: 40px;
  color: #a2100e;
  margin-right: 10px;
}

/deep/ .btndelpackage {
  position: absolute;
  top: -55px;
  right: 0px;
  font-size: 12px;
  line-height: 30px;
  color: #707070;
}

/deep/ .btndelpackage span {
  display: flex;
}

/deep/ .btndelpackage i {
  font-size: 40px;
  color: #707070;
  margin-right: 10px;
}

/deep/ .el-checkbox .el-checkbox__label {
  padding-left: 20px;
  font-size: 16px;
}

.need-seal-wrapper {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.remark {
  color: #707070;
  font-size: 14px;
  padding-left: 20px;
}

/deep/ .el-collapse-item {
  margin-bottom: 60px;
}
</style>
